// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:e-2Jzp */\n.tP0c_{grid-gap:var(--audio-spacing-16);display:grid;gap:var(--audio-spacing-16);grid-template-columns:1fr}.wppCT{word-wrap:break-word;font-size:var(--audio-font-size-17);font-weight:400;line-height:var(--audio-line-height-24);margin:0;overflow-wrap:break-word;white-space:pre-wrap}.TvU4Q{color:var(--audio-content-secondary)}.GcG7b{display:flex;flex-wrap:wrap;gap:var(--audio-spacing-8)}.BMB9i{display:contents;-webkit-text-decoration:none;text-decoration:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"details": "tP0c_",
	"description": "wppCT",
	"empty": "TvU4Q",
	"tags": "GcG7b",
	"tagLink": "BMB9i"
};
export default ___CSS_LOADER_EXPORT___;
